import { render, staticRenderFns } from "./pi-swipe.vue?vue&type=template&id=672f5919&"
import script from "./pi-swipe.vue?vue&type=script&lang=js&"
export * from "./pi-swipe.vue?vue&type=script&lang=js&"
import style0 from "./pi-swipe.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports